import type { CasesProps } from "./types";
import CasesCard from "@/components/ui/cases-block/CasesCard";
import Image from "next/image";

export default function CasesMobile(props: CasesProps) {
    const { items } = props;

    if (!items?.length) return null;

    return (
        <div className={"flex flex-col gap-20 py-4 relative"}>
            {items.map((item, i) => {
                return (
                    <div key={i} className={"relative"}>
                        <CasesCard item={item} />

                        {i !== items.length - 1 && (
                            <Image
                                src="/images/cases-mobile-divider.svg"
                                alt="card divider"
                                width={11}
                                height={84}
                                sizes="100vw"
                                className="absolute top-full left-1/2 -translate-x-1/2 z-10 w-[11px] h-auto"
                            />
                        )}
                    </div>
                );
            })}
        </div>
    );
}
